import r from"react";function t({ScriptComponent:t,src:e}){return r.createElement(t,{src:e})}export{t as LimeScript};
//# sourceMappingURL=script.js.map
